export default __webpack_public_path__ + "static/print-0e59c7966c18054bcbc609128eaef6c1.jpg";